export enum DirectDebitType {
    SEPA,
    BACS
}